// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"9750d444","436":"78e83110","773":"cc00fa56","781":"0333a626"}[chunkId] + ".chunk.css";
};